import React from 'react';
import { useNavigate } from 'react-router-dom';
import { KnowledgeFile } from '../../types';
import { getFileIcon } from '../../utils/file-types';
import { formatFileSize } from '../../utils/file-types';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useI18n } from '../../i18n';

dayjs.extend(relativeTime);

interface FileSearchResultProps {
  file: KnowledgeFile;
  onClose: () => void;
}

const FileSearchResult: React.FC<FileSearchResultProps> = ({ file, onClose }) => {
  const navigate = useNavigate();
  const FileIcon = getFileIcon(file.type);
  const { t } = useI18n();
  
  const handleClick = () => {
    navigate(`/uadmin/files/${file.id}`);
    onClose();
  };
  
  return (
    <button
      onClick={handleClick}
      className="flex items-center w-full p-2 text-left rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50"
    >
      <div
        className="flex items-center justify-center w-10 h-10 mr-3 rounded-md"
        style={{ backgroundColor: `${file.type === 'document' ? '#e0f2fe' : file.type === 'image' ? '#ecfdf5' : file.type === 'video' ? '#fee2e2' : file.type === 'pdf' ? '#fff7ed' : '#f3f4f6'}` }}
      >
        <FileIcon size={20} className={`${file.type === 'document' ? 'text-blue-500' : file.type === 'image' ? 'text-emerald-500' : file.type === 'video' ? 'text-red-500' : file.type === 'pdf' ? 'text-orange-500' : 'text-gray-500'}`} />
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex items-center">
          <h4 className="text-sm font-medium text-gray-900 truncate">{file.name}</h4>
        </div>
        <div className="flex items-center text-xs text-gray-500">
          <span>{file.type}</span>
          <span className="mx-1">•</span>
          <span>{formatFileSize(file.size)}</span>
          <span className="mx-1">•</span>
          <span>{t('updatedLabel')} {dayjs(file.updatedAt).fromNow()}</span>
        </div>
      </div>
      
      {file.tags.length > 0 && (
        <div className="flex ml-2 space-x-1">
          {file.tags.slice(0, 2).map((tag) => (
            <span
              key={tag.id}
              className="flex items-center px-2 py-0.5 text-xs rounded-full"
              style={{ backgroundColor: `${tag.color}20`, color: tag.color }}
            >
              {tag.name}
            </span>
          ))}
          {file.tags.length > 2 && (
            <span className="flex items-center px-2 py-0.5 text-xs rounded-full bg-gray-100 text-gray-500">
              +{file.tags.length - 2}
            </span>
          )}
        </div>
      )}
    </button>
  );
};

export default FileSearchResult;